import styled from 'styled-components';

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  margin: 16px 0;
`;

ButtonGroup.displayName = 'ButtonGroup';
export default ButtonGroup;
